import styled from 'styled-components';

const QuestionTitle = styled.h2`
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 135%;
  margin-bottom: 0.8rem;
`;

export default QuestionTitle;
